import { css } from 'styled-components';
import token from 'styled-token';
import { DropdownMixin } from './DropdownMixin';

/** @class MenuMixin */
/**
 * Styles for the `Menu` component.
 *
 * @example
 * import { MenuMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${MenuMixin}
 * `;
 *
 * <Component />
 *
 * @method
 * @param {object} props
 * @param {object} props.theme
 * @return {CSSObject}
 */
export var MenuMixin = function MenuMixin(props) {
  return token({
    minWidth: 'Dialog.minWidth',
    maxWidth: 'Dialog.maxWidth'
  }, function (_ref) {
    var minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth;
    return css(["", " min-width:", "px;max-width:", "px;"], DropdownMixin(props), minWidth, maxWidth);
  })(props);
};